export function reduceLongSenteces(value: string, max: number = 40) {
  if (value && value.length > max) {
    return `${value.slice(0, max)}...`
  }
  return value
}
